const sangjoFAQData = [
  {
    question: "장례 비용/음식 비용을 최대한 줄일 수 있나요?",
    answer:
      "고이장례연구소(1666-9784)에서는 미사용 품목은 100% 공제해드리며, 품목별 가격 정찰제를 시행중입니다. 장례식장 비용 비교를 통하여 500만원이상 비용을 줄이며, 합리적으로 장례를 치를 수 있게 상담해드립니다. 특히, 음식 비용의 경우 2~300만원의 차이가 나기도 하는데 고이에서 파견한 장례도우미를 통하여 합리적으로 장례를 치를 수 있게 도와드립니다. <a href='https://www.goifuneral.co.kr/match/request/'>전체 비용 알아보기</a>",
  },
  {
    question: "장례지도사가 빈소에 함께하며 장지까지 동행하나요?",
    answer:
      "장례식장에 연락하여 장례를 진행하는 경우 장례 중 빈소를 잠깐 관리하는 역할을 합니다. 고이의 장례지도사는 장례식장부터 장지, 화장장 예약 등 장례 전반을 책임지며 합리적인 장례를 도와드립니다. 임종 순간부터 장지까지 동행하는 장례지도사, 미리 알아보세요. 고이장례연구소(1666-9784) <a href='https://www.goifuneral.co.kr/review/'>장례지도사 후기 보기</a>",
  },
  {
    question: "빈소를 미리 예약할 수 있나요?",
    answer:
      "아니요, 빈소는 임종 시점에 이용 가능 여부를 확인해야합니다. 특히 지나치게 큰 빈소를 이용하지 않도록 상담해드리고 염두에 두고 있는 빈소의 비용이나, 주변 장례식장 비용 비교까지 도와드립니다.",
  },
];

const faqList = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity:
    sangjoFAQData.map((item) => {
      return {
        "@type": "Question",
        name: item.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: item.answer,
        },
      };
    }) || [],
};

const reviewResult = {
  "@context": "https://schema.org",
  "@type": "Product",
  name: "고이",
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "4.9",
    bestRating: "5",
    ratingCount: "178",
  },
  review: [
    {
      "@type": "Review",
      name: "고이",
      author: {
        "@type": "Person",
        name: "김**",
      },
      reviewBody:
        "언젠가 발생할 제 인생의 다른 상에도 고이와 함께하려고 합니다. 아들이 먼저 갔는데 내가 나이가 많아 어찌해야 할지 막막했는데 최 선생이 멀리서 와서 신경 안 쓰게 알아서 다해주니까 너무 고마웠습니다. ",
      reviewRating: {
        "@type": "Rating",
        ratingValue: "5",
      },
    },
    {
      "@type": "Review",
      name: "고이",
      author: {
        "@type": "Person",
        name: "박**",
      },
      reviewBody:
        "장례 경험이 없는 조문객들도 너무 좋으신 분이라고 다른 상조 회사 분들이랑 다르다고 말씀하시더라고요. 할머니가 코로나로 인해 중환자실 2주 계시다 요양병원으로 가신 날 부터 준비를 해야할거같아 그때부터 알아보게 된 곳입니다. 상조가 이미 가입되어있었지만 고이와 비교 해보니 금액적으로 100만원 이상 차이도 났고 사",
      reviewRating: {
        "@type": "Rating",
        ratingValue: "5",
      },
    },
    {
      "@type": "Review",
      name: "고이",
      author: {
        "@type": "Person",
        name: "남**",
      },
      reviewBody:
        "고이 장례지도사님을 저희 아버지 장례지도사로 만나게 된 것은 하나님의 마지막 선물인 것 같습니다. 경황도 없고 큰 슬픔에 빠진 저희 가족들에게 하나부터 열까지 진심으로 친절하게 꼼꼼히 챙겨주셨습니다.",
      reviewRating: {
        "@type": "Rating",
        ratingValue: "5",
      },
    },
    {
      "@type": "Review",
      name: "고이",
      author: {
        "@type": "Person",
        name: "김**",
      },
      reviewBody:
        "제가 마지막으로 가장 잘한 효도인 것 같네요. 감사했습니다. 갑작스럽게 어머님이 돌아가셔서 정신이 없는 가운데 고이에 전화를 하게되었습니다. 장례 3일동안 오로지 문상객에만 집중할 수 있게 모든 절차나 장지까지 전부 다 알아봐 주시고",
      reviewRating: {
        "@type": "Rating",
        ratingValue: "5",
      },
    },
  ],
};

export const commonRichSearch = { faqList, reviewResult };
